import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import FilterSection from "@SearchResults/features/sidebar/components/FilterSection";
import getUniqueStationsForActiveTab
    from "@SearchResults/features/sidebar/features/stationFilters/functions/getUniqueStationsForActiveTab";
import Station from "@SearchResults/features/sidebar/features/stationFilters/components/Station";
import {RouteTransferTypeValuesType} from "@Route/features/transportType/types/routeTransferType.type";
import ParamsType from "@SearchResults/types/params/Params.type";

type DepartureStationFilterProps = {
    searchData: SearchResultsRtkQueryResponseType,
    activeTab: RouteTransferTypeValuesType,
    params?: ParamsType
}

function DepartureStationFilter(props: DepartureStationFilterProps) {
    // Use raw routes for station filters - we want to show all possible stations as options
    // The experiment filter should only affect the actual route results, not the filter options
    const activeStations = getUniqueStationsForActiveTab({
        searchData: props.searchData,
        tab: props.activeTab,
        stations: "departureStation",
        // Don't apply experiment filter to station options - use raw routes
    })

    if (activeStations.length < 1) {
        return null;
    }

    return (
        <FilterSection
            filterDataKey="filterDepartureStation"
            translationKey="search_results.filter_by.departure_stations.label"
            isToggleable={activeStations.length > 5}
        >
            {activeStations.map((station) => (
                <Station
                    key={station.name}
                    station={station}
                    type="departure"
                />
            ))}
        </FilterSection>
    );
}

export default DepartureStationFilter;